export const SET_NEW_SELL_MAGAZINE_DAY_EDITIONS = 'SET_NEW_SELL_MAGAZINE_DAY_EDITIONS';
export const SET_MAGAZINE_EDITIONS = 'SET_MAGAZINE_EDITIONS'